export const TipoConsulta = [
    {
        codigo: 1,
        opcion: "CON CONSECUTIVO"
    }, {
        codigo: 2,
        opcion: "DNI EMPLEADOR"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/modelo/TipoConsulta.ts